import { render, staticRenderFns } from "./TermsAndConditionsBoutiqueSoBook.vue?vue&type=template&id=140530e8&scoped=true&"
import script from "./TermsAndConditionsBoutiqueSoBook.vue?vue&type=script&lang=js&"
export * from "./TermsAndConditionsBoutiqueSoBook.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "140530e8",
  null
  
)

export default component.exports